import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { fetchActiveIncidentsService } from '../../../services/active-incidents/index.tsx';
import { emptyServiceDataState } from '../../constants.tsx';
import type { ActiveIncidentsState, ServiceDataLoadingState } from '../../types.tsx';

const fetchActiveIncidents =
	(affectedServicesFieldId: string, serviceIds: string[]): Action<ActiveIncidentsState> =>
	async ({ getState, setState }) => {
		const activeIncidents = { ...getState() };

		const loadingActiveIncidents = serviceIds.reduce((accActiveIncidents, serviceId) => {
			const { data, error, loadedAt } = activeIncidents[serviceId] ?? emptyServiceDataState;
			const serviceDataLoadingState: ServiceDataLoadingState = {
				data,
				loading: true,
				error,
				loadedAt,
			};
			return {
				// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
				...accActiveIncidents,
				[serviceId]: serviceDataLoadingState,
			};
		}, activeIncidents);
		setState(loadingActiveIncidents);

		const serviceResponse = await fetchActiveIncidentsService(affectedServicesFieldId, serviceIds);
		// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'ActiveIncidentsServiceResponse'.
		if (serviceResponse.data) {
			setState(
				// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'ActiveIncidentsServiceResponse'.
				Object.keys(serviceResponse.data).reduce((accActiveIncidents, serviceId) => {
					const serviceDataLoadingState: ServiceDataLoadingState = {
						// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'ActiveIncidentsServiceResponse'.
						data: { activeIncidents: serviceResponse.data[serviceId] },
						loading: false,
						error: null,
						loadedAt: Date.now(),
					};
					return {
						// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
						...accActiveIncidents,
						[serviceId]: serviceDataLoadingState,
					};
				}, activeIncidents),
			);
		} else {
			setState(
				serviceIds.reduce((accActiveIncidents, serviceId) => {
					const { data, loadedAt } = activeIncidents[serviceId] ?? emptyServiceDataState;
					const serviceDataLoadingState: ServiceDataLoadingState = {
						data,
						loading: false,
						// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ActiveIncidentsServiceResponse'.
						error: serviceResponse.error,
						loadedAt,
					};
					return {
						// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
						...accActiveIncidents,
						[serviceId]: serviceDataLoadingState,
					};
				}, activeIncidents),
			);

			fireErrorAnalytics({
				meta: {
					id: 'fetchActiveIncidents',
					packageName: 'jiraServicedeskLinkedObjectIncidentsStore',
				},
				attributes: {
					// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ActiveIncidentsServiceResponse'.
					errorType: serviceResponse.error,
				},
			});
		}
	};

export default fetchActiveIncidents;
